import React from 'react';
import { Link } from 'react-router-dom';

import { Skeleton } from '@dashboard/components/ui/skeleton';

function List({ children }) {
  return <div className="flex flex-col gap-y-4 mt-4">{children}</div>;
}

function ListItem({ href, children }) {
  return (
    <Link
      to={href}
      className="-m-2 p-2 rounded-md hover:bg-gray-50 dark:hover:bg-muted w-full min-w-0 flex text-sm h-16 gap-x-2"
    >
      {children}
    </Link>
  );
}

function Left({ children }) {
  return <div className="min-w-0 flex-1 space-y-1 truncate">{children}</div>;
}

function Right({ children }) {
  return <div className="ml-auto shrink-0 text-right space-y-1">{children}</div>;
}

function PrimaryText({ children }) {
  return <p className="truncate font-medium">{children}</p>;
}

function SecondaryText({ children }) {
  return <p className="text-gray-500 dark:text-muted-foreground truncate">{children}</p>;
}

function Loading({ count = 4 }) {
  return Array.from({ length: count }).map((_, index) => (
    <div key={index} aria-hidden="true" className="-m-2 p-2 w-full flex h-16 gap-x-2">
      <div className="min-w-0 flex-1 space-y-2 pt-0.5">
        <Skeleton className="h-4 w-48 max-w-full" />
        <Skeleton className="h-4 w-32 max-w-full" />
      </div>
      <div className="ml-auto flex flex-col items-end space-y-2 pt-0.5">
        <Skeleton className="h-4 w-12" />
        <Skeleton className="h-4 w-28" />
      </div>
    </div>
  ));
}

function EmptyState({ children }) {
  return <div className="text-gray-500 dark:text-muted-foreground">{children}</div>;
}

const StatisticsList = {
  List: List,
  Item: ListItem,
  Left: Left,
  Right: Right,
  PrimaryText: PrimaryText,
  SecondaryText: SecondaryText,
  EmptyState: EmptyState,
  Loading: Loading,
};

export default StatisticsList;
